import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import {
  PrivacyWrapper,
  ContentJan2020,
  DescriptionJan2020,
} from '../../v2/components/privacy';
import { PRIVACY_JAN_2020_LINKS_LIST } from '../../v2/constants';
import type { ISiteData } from '../../v2/interfaces/ISiteData';

const PrivacyJan2020: React.FC = () => {
  const {
    site: {
      siteMetadata: { contact },
    },
  } = useStaticQuery<ISiteData>(graphql`
    query GetPrivacyJanContactEmail {
      site {
        siteMetadata {
          contact {
            email
          }
        }
      }
    }
  `);
  return (
    <PrivacyWrapper
      revisedDate="Last Revised: January 1, 2020"
      content={<ContentJan2020 hoverEmail={contact.email} />}
      tableOfContent={PRIVACY_JAN_2020_LINKS_LIST}
      description={<DescriptionJan2020 />}
    />
  );
};

export default PrivacyJan2020;
